const THEMES = [
  // 2026 夏
  { start: "2026-05-08", end: "2026-05-11", name: "ThemeLaodong", label: "劳动节" },
  { start: "2026-05-12", end: "2026-05-18", name: "ThemeLixia", label: "立夏" },
  { start: "2026-05-19", end: "2026-05-31", name: "ThemeXiaoman", label: "小满" },
  { start: "2026-06-01", end: "2026-06-14", name: "ThemeChildrenDay", label: "六一" },
  { start: "2026-06-15", end: "2026-06-27", name: "ThemeDuanwu", label: "端午" },
  { start: "2026-06-28", end: "2026-07-04", name: "ThemeBirthdayLaodi", label: "老弟生日" },
  { start: "2026-07-05", end: "2026-07-16", name: "ThemeJiandang", label: "建党" },
  { start: "2026-07-17", end: "2026-07-21", name: "ThemeQiaoqian", label: "乔迁" },
  { start: "2026-07-22", end: "2026-07-27", name: "ThemeDahan", label: "大暑" },
  { start: "2026-07-28", end: "2026-08-07", name: "ThemeHunian", label: "结婚纪念" },
  { start: "2026-08-08", end: "2026-08-31", name: "ThemeQixi", label: "七夕" },

  // 2026 秋
  { start: "2026-09-01", end: "2026-09-09", name: "ThemeQiuyi", label: "秋意" },
  { start: "2026-09-10", end: "2026-09-22", name: "ThemeJiaoshi", label: "教师节" },
  { start: "2026-09-23", end: "2026-09-30", name: "ThemeQiufen", label: "秋分" },
  { start: "2026-10-01", end: "2026-10-15", name: "ThemeGuoqing", label: "国庆" },
  { start: "2026-10-16", end: "2026-10-20", name: "ThemeZhongqiu", label: "中秋" },
  { start: "2026-10-21", end: "2026-10-25", name: "ThemeZhongzheng", label: "重阳" },
  { start: "2026-10-26", end: "2026-10-30", name: "ThemeQiuqu", label: "秋趣" },
  { start: "2026-10-31", end: "2026-11-06", name: "ThemeWansheng", label: "万圣节" },
  { start: "2026-11-07", end: "2026-11-25", name: "ThemeLidong", label: "立冬" },
  { start: "2026-11-26", end: "2026-12-10", name: "ThemeGratitude", label: "感恩节" },
  { start: "2026-12-11", end: "2026-12-31", name: "ThemeDongzhi", label: "冬至" },

  // 2027 春
  { start: "2027-01-01", end: "2027-01-19", name: "ThemeXinnian", label: "元旦" },
  { start: "2027-01-20", end: "2027-02-16", name: "ThemeBirthdayJifu", label: "Jifu生日" },
  { start: "2027-02-17", end: "2027-03-01", name: "ThemeChunjie", label: "春节" },
  { start: "2027-03-02", end: "2027-03-08", name: "ThemeBirthdayBaobao", label: "宝宝生日" },
  { start: "2027-03-09", end: "2027-04-02", name: "ThemeChunfen", label: "春分" },
  { start: "2027-04-03", end: "2027-04-09", name: "ThemeBirthdayMingming", label: "明明生日" },
  { start: "2027-04-10", end: "2027-04-12", name: "ThemeGuyu", label: "谷雨" },
  { start: "2027-04-13", end: "2027-04-26", name: "ThemeLianai", label: "恋爱纪念" },
  { start: "2027-04-27", end: "2027-05-04", name: "ThemeBirthdayGaoxing", label: "小高兴生日" },
];

export default THEMES;

export function getCurrentTheme() {
  const today = new Date();
  for (const t of THEMES) {
    const s = new Date(t.start);
    const e = new Date(t.end);
    e.setHours(23, 59, 59, 999);
    if (today >= s && today <= e) {
      return t;
    }
  }
  return { name: "ThemeDefault", label: "默认" };
}
